import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import config from 'core/config/local';
import reportWebVitals from './reportWebVitals';
import 'react-datepicker/dist/react-datepicker.css';

let root: ReturnType<typeof createRoot> | null = null;

export default function renderApp({ App }: { App: React.ReactElement }) {
  if (config.sentry) {
    console.info('Initializing sentry with config', config.sentry);
    Sentry.init(config.sentry);
  } else {
    console.info('Skipping sentry setup');
  }

  reportWebVitals();

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root container not found!');
  }

  if (!root) {
    root = createRoot(container);
  }

  root.render(App);

  return root; // Return the root in case you want to unmount later
}
